import type { DriverMetricAdjustmentAdminDto } from '@/backend/market'
import {
  DriverMetricAdjustmentEntity,
  DriverMetricAdjustmentEventEntity
} from '../../domain/entities/DriverMetricAdjustmentEntity'

export class DriverMetricAdjustmentModel extends DriverMetricAdjustmentEntity {
  constructor(data: DriverMetricAdjustmentAdminDto) {
    super()
    Object.assign(this, data)
    this.events = data.events?.map((event) => Object.assign(new DriverMetricAdjustmentEventEntity(), event))
  }
}
